export class Categories {
    CategoryId :number
    NameCategory :string
    categoryfortable:string
    constructor(){
        this.CategoryId=null;
        this.NameCategory="הכל";
        this.categoryfortable;}
}
